type Props = {
  label?: string;
  /** When true, fills the viewport height (for auth / shell-level loading). */
  fullHeight?: boolean;
};

export function LoadingState({ label = "Loading", fullHeight = false }: Props) {
  return (
    <div className={`loading-state${fullHeight ? " loading-state--full" : ""}`} role="status" aria-live="polite">
      <div className="loading-state-dots" aria-hidden="true">
        <span />
        <span />
        <span />
      </div>
      <div className="loading-state-label">{label}</div>
    </div>
  );
}
